import React, { useEffect } from "react";
import classes from "./Cybertracker.module.scss";
import Heading from "../../../components/caseStudy/heading/Heading.tsx";
import Info, { Feature, Topic } from "../../../components/caseStudy/info/Info.tsx";
import logo from "./media/logo.svg";
import OtherProjects from "../../../components/caseStudy/other-projects/OtherProjects.tsx";
import { ECaseStudy } from "../../../enums/case-study.enum.ts";
import { useTranslation } from "react-i18next";
import OrganizationSeo from "../../../components/Seo/OrganizationSeo.tsx";

const Cybertracker = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  const title = [t('cybertracker.title'), t('cybertracker.blueTitle')]

  const description = [
    t('cybertracker.text')
  ]

  const infoTitle = t('cybertracker.info.title');

  const infoTitleMessage = t('cybertracker.info.text')
  const topics: Topic[] = t('cybertracker.topic', {returnObjects: true})

  const features: Feature = {
    list: t('cybertracker.featuresList', {returnObjects: true})
  }

  const rightBlock = {
    platforms: t('cybertracker.rightBlock.platforms', {returnObjects: true}),
    services: t('cybertracker.rightBlock.services', {returnObjects: true}),
    audience: t('cybertracker.rightBlock.audience', {returnObjects: true}),
    field: t('cybertracker.rightBlock.field', {returnObjects: true})
  }

  return (
      <>
        <OrganizationSeo
            title="Goteco: Secure and Scalable GovTech and Business Solutions"
            description="Goteco specializes in developing secure, scalable systems that boost efficiency across public and private sectors, optimizing processes in manufacturing, e-commerce, and construction industries."
            url="https://go-te.co/"
            image="https://go-te.co/logo.svg"
        />

        <section className={classes.section} id="nav-dark">
          <Heading title={title} description={description} maxWidth={800} imageName={'cybertracker.webp'} />

          <Info
              title={infoTitle}
              titleMessage={infoTitleMessage}
              topics={topics}
              features={features}
              featuresText={t('cybertracker.featuresText')}
              rightBlock={rightBlock}
          />

          <div className={classes["image-section"]}>
            <div className={classes["overlay"]}></div>
            <div className={classes["image-container"]}>
              <img className={classes.logo} src={logo} alt="Cybertracker logo" />
              <div className={classes.text}>
                {t('cybertracker.bottomText')}
              </div>
            </div>
          </div>

          <OtherProjects name={ECaseStudy.CYBERTRACKER} />
        </section>
      </>
  );
};

export default Cybertracker;